<button
  type="button"
  class="border-line-default hover:enabled:bg-alpha-on-surface focus:enabled:bg-alpha-on-surface flex h-9 w-full shrink-0 items-center gap-1.5 rounded-lg border px-2 transition"
  [ngClass]="{ 'opacity-80': disabled }"
  [disabled]="disabled"
  (click)="OptionOp.toggle($event)">
  <img
    src="/assets/images/flag/{{ CountryExtMap[value].code.toLowerCase() || 'id' }}.svg"
    alt=""
    class="border-line-default h-4 w-5 rounded border object-cover" />
  <p class="text-text-subtle grow text-left text-xs font-medium">{{ value || "62" }}</p>
  <ic-chevron-down
    class="text-icon-subtle block h-5 w-5 shrink-0 rotate-0 transition"
    [ngClass]="{ 'rotate-180': OptionOp.overlayVisible }" />
</button>

<p-popover
  #OptionOp
  styleClass="h-80 !border-line-default !bg-bg-surface-default !rounded-lg">
  <ng-template pTemplate="content">
    <div class="-m-3 h-80 overflow-auto">
      <div
        class="bg-bg-surface-default border-b-line-default sticky top-0 right-0 left-0 border-b p-2">
        <ng-container *ngTemplateOutlet="Search" />
      </div>
      <ng-container *ngTemplateOutlet="Option" />
    </div>
  </ng-template>
</p-popover>

<ng-template #Search>
  <app-input-text
    boxStyleClass="bg-alpha-on-surface"
    placeholder="Cari negara atau kode telepon"
    [autofocus]="autofocus"
    [(ngModel)]="extSearch"
    (ngModelChange)="handleSearchExt()">
    <div
      template="prefix"
      class="flex aspect-square items-center justify-center">
      <ic-search-outline class="text-icon-subtle block h-5 w-5" />
    </div>
  </app-input-text>
</ng-template>

<ng-template #Option>
  <div class="flex flex-col">
    <ng-container *ngIf="CountryExt.length">
      <ng-container *ngFor="let option of CountryExt">
        <app-button
          class="w-full"
          theme="transparent"
          styleClass="flex items-center gap-2 w-full"
          (click)="writeValue(option.ext)">
          <img
            src="/assets/images/flag/{{ option.code.toLowerCase() }}.svg"
            alt=""
            class="border-line-default h-6 w-8 overflow-hidden rounded border object-cover" />
          <p class="grow text-left text-xs">{{ option.country }} ({{ option.ext }})</p>
          @if (option.ext === value) {
            <ic-tick-circle-outline class="text-text-success block h-4 w-4" />
          }
        </app-button>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!CountryExt.length">
      <div class="flex flex-col items-center justify-center gap-1">
        <p class="text-text-subtler text-sm font-semibold">Tidak ada hasil.</p>
        @if (extSearch) {
          <p class="text-text-subtler text-xs">Coba kata kunci lain.</p>
        }
      </div>
    </ng-container>
  </div>
</ng-template>
